import { http } from '@/utils/http.util';

export default class visitorService {
   async postVisitor(page_type_key: 'landing' | 'registration', referral_id: Number) {
      let body = {
         page_type_key,
         referral_id,
      };
      return await http.post('/api/visitor', body).then((response) => {
         return response.data;
      });
   }
}

